var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-fg-id":_vm.id}},[_vm._t("default",null,{"activeError":_vm.activeErrors,"firstError":_vm.firstError})],2)}
var staticRenderFns = []

export { render, staticRenderFns }